// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2HocE","header":"ReportDetails_header__1NC7S","title":"ReportDetails_title__1BOk0","left":"ReportDetails_left__1e7ea"};